import Field from "csi/def/Field";
import Widget from "csi/form/Widget";
import reflection from "csi/reflection";
import { ATTR_NAME } from "csi/typings";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
const NameLinkedStyleBOMsForm = declare(Widget, {
	FIELD_STYLE_BOM_NAME: "StyleBOMName",
	SUBTYPE: "Subtype",

	_resolveView() {
		this.inherited(arguments);
		const ctx = this.getContext();
		const themeBom = ctx.getNode();
		this.addFixedValue("ThemeBOM", themeBom[ATTR_NAME]);
		this.addFixedValue(this.SUBTYPE, reflection.getSubtypeName(themeBom.Subtype));
		this.setFieldDisabled(this.SUBTYPE, true);
		this.insertField(lang.mixin(new Field(), {
			m_bRequired: true,
			m_label: this.FIELD_STYLE_BOM_NAME,
			
		}));
	},
});
export = NameLinkedStyleBOMsForm;